import React, { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AccessControl from "@/components/AccessControl";
import Authority from "@/enum/Authority";

import NotFound from "@/scenes/404";
import OrderManagement from "@/scenes/OrderManagement";
const ManualOrder = lazy(() => import("./ManualOrder"));
const OrderManagementForAllShop = lazy(() => import("@/scenes/OrderManagementForAllShop"));
const MerchantsManualCancelEwaybill = lazy(() => import("@/scenes/MerchantsManualCancelEwaybill"));
const OrderSearch = lazy(() => import("@/scenes/OrderSearch"));

interface OMSRoutesProps {}

/**
 * 订单管理相关路由模块
 */
const OMSRoutes: React.FC<OMSRoutesProps> = React.memo(function (props) {
    return (
        <Switch>
            {/* 订单列表页 */}
            <Route exact path="/order/list">
                <AccessControl authority={Authority.ROLE_ORDER_LIST}>
                    <OrderManagement />
                </AccessControl>
            </Route>

            {/* 全部店铺订单页 */}
            <Route exact path="/order/list/allShop">
                <AccessControl authority={Authority.ROLE_ORDER_LIST}>
                    <OrderManagementForAllShop />
                </AccessControl>
            </Route>

            {/* 售后管理 */}
            <Route
                exact
                path="/order/refund"
                render={({ location }) => (
                    <Redirect to={{ pathname: "/refund/list", search: location.search, hash: location.hash }} />
                )}
            />

            {/* 手工订单 */}
            <Route path="/manualOrder">
                <AccessControl authority={Authority.ROLE_ORDER_IMPORT}>
                    <ManualOrder />
                </AccessControl>
            </Route>

            {/* 查询订单 */}
            <Route exact path="/order/search">
                <AccessControl authority={Authority.ROLE_ORDER_SEARCH}>
                    <OrderSearch />
                </AccessControl>
            </Route>

            {/* 商家手动回收单号页面 */}
            <Route exact path="/merchantsCancelEwaybills" component={MerchantsManualCancelEwaybill} />

            <Route path="*" component={NotFound} />
        </Switch>
    );
});

export default OMSRoutes;
